// import hooks
import { Dispatch } from 'react';

// import types
import { TabType } from './CLASettings.types';

// import components
import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPageContext';
import CapPlanTab from './sections/CapPlanTab';
import DeviatingTab from './sections/DeviatingTab';
import ExtraHoursTab from './sections/ExtraHoursTab';
import GeneralTab from './sections/GeneralTab';
import LeaveTab from './sections/LeaveTab';
import EndOfEmploymentSettlementTab from './sections/EndOfEmploymentSettlementTab';
import ExpiryHoursInOctopusTab from './sections/ExpiryHoursInOctopusTab';
import { useSelector } from 'hooks';
import SpecialLeaveTab from './sections/SpecialLeaveTab';

type SwitcherProps = {
  currentTab: TabType;
  setCurrentSchema: Dispatch<any>;
};

const TabSwitcher = ({ currentTab, setCurrentSchema }: SwitcherProps) => {
  const { isEditable } = useEditPageContext();
  const {
    hasProcessEndOfEmploymentSettlementAccess,
    hasSpecialLeaveImportModule
  } = useSelector((state) => state.grants);

  switch (currentTab) {
    case TabType.GENERAL:
      return (
        <GeneralTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.LEAVE:
      return (
        <LeaveTab setCurrentSchema={setCurrentSchema} isEditable={isEditable} />
      );
    case TabType.EXTRA_HOURS:
      return (
        <ExtraHoursTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.CAP_PLAN:
      return (
        <CapPlanTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.DEVIATING:
      return (
        <DeviatingTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.END_OF_EMPLOYMENT_SETTLEMENT:
      return (
        hasProcessEndOfEmploymentSettlementAccess && (
          <EndOfEmploymentSettlementTab
            setCurrentSchema={setCurrentSchema}
            isEditable={isEditable}
          />
        )
      );
    case TabType.EXPIRY_HOURS_IN_OCTOPUS:
      return (
        <ExpiryHoursInOctopusTab
          setCurrentSchema={setCurrentSchema}
          isEditable={isEditable}
        />
      );
    case TabType.SPECIAL_LEAVE:
      return (
        hasSpecialLeaveImportModule && (
          <SpecialLeaveTab
            setCurrentSchema={setCurrentSchema}
            isEditable={isEditable}
          />
        )
      );
    default:
      return <div />;
  }
};

export default TabSwitcher;
